import { render } from "./orderprogressescarousel.vue?vue&type=template&id=176fb6e7&scoped=true"
import script from "./orderprogressescarousel.vue?vue&type=script&lang=js"
export * from "./orderprogressescarousel.vue?vue&type=script&lang=js"

import "./orderprogressescarousel.vue?vue&type=style&index=0&id=176fb6e7&scoped=true&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176fb6e7"]])

export default __exports__